module.exports = __webpack_public_path__ + "assets/faa634cf67bc1c48156ac47a27954793.png";